import React, { useEffect, useState } from "react";
import Button from "../../components/ui/button";
import { Input } from "../../components/ui/input";
import { Label } from "../../components/ui/label";
import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from "../../components/ui/select";
import { CreditCard } from "lucide-react";
import axios from "axios";
import { useTranslation } from "react-i18next";
import { URLS } from "../../API/API endpoints";
import { useFormik } from "formik";
import { InputBox, Password } from "../CustomWidgets/InputBox";
import * as Yup from "yup";
import SelectBox, { MultiSelectBox } from "../CustomWidgets/SelectBox";
import { GetGeoFencing } from "./GetGeoFencing";
import * as yup from "yup";
import FlagIcon from "../../assets/egypt.svg";

const ShopRegistration = ({ mobile, data, onDataSubmit }) => {
  const { i18n, t } = useTranslation();

  const [shoptype, setshoptype] = useState([]);
  const [categories, setCategories] = useState([]);
  const [selectedPolygon, setSelectedPolygon] = useState({});
  const [selectedLocation, setSelectedLocation] = useState(null);
  const [locationPermission, setLocationPermission] = useState(false);

  const validationSchema = Yup.object({
    shopType: yup.string().required("Shop Type is required"),
    shopName: yup.string().required("Shop Name is required"),
    phoneNumber: yup
      .string()
      .required("Required")
      .min(8, "Invalid phone number"),
    emailId: yup.string().email("Invalid email").required("Required"),
    password: yup
      .string()
      .min(6, "Password must be at least 6 characters")
      .matches(
        /^(?=.*[A-Z])(?=.*[0-9])(?=.*[!@#$%^&*])[a-zA-Z0-9!@#$%^&*]+$/,
        "Password must contain at least 1 uppercase letter, 1 number and 1 special character"
      )
      .matches(
        /^[^0-9!@#$%^&*]/,
        "Password cannot start with a number or special character"
      )
      .required("Required"),

    confirmPassword: yup
      .string()
      .oneOf([yup.ref("password"), null], "Passwords must match")
      .required("Required"),

    addressLine1: yup.string().required("Required"),
    street: yup.string().required("Required"),
    city: yup.string().required("Required"),
    governorate: yup.string().required("Required"),
    categories: yup.array().when("shopType", {
      is: (value) => {
        const selected = shoptype?.find((item) => item?.shop_type_id == value);
        return selected?.show_sub_cat_sign_up === true;
      },
      then: () =>
        yup
          .array()
          .min(1, "Please select at least one category")
          .required("Required"),
      otherwise: () => yup.array().notRequired(),
    }),
  });
  useEffect(() => {
    fetchData();
  }, []);
  useEffect(() => {
    if (selectedPolygon?.level) {
      formik.setFieldValue("city", selectedPolygon.level);
    }
  }, [selectedPolygon?.level]);
  useEffect(() => {
    if (!locationPermission) {
      navigator.geolocation.getCurrentPosition(
        (position) => {
          const newPos = {
            lat: position.coords.latitude,
            lng: position.coords.longitude,
          };
          setSelectedLocation(newPos);
          handleLocationChange(newPos);
        },
        (error) => {
          console.error("Error retrieving location", error);
        }
      );
    }
  }, [locationPermission]);

  const fetchData = async () => {
    try {
      const response = await axios.post(URLS.GET_STORE_TYPE, {
        lang: i18n.language == "ar" ? "ar_001" : "en_US",
      });

      setshoptype(response?.data?.result?.[0]?.response);
    } catch (error) {
      console.error(error);
    }
  };

  const GetCategorires = async (id) => {
    try {
      const response = await axios.post(URLS.CATEGORIES_BY_SHOP_TYPE, {
        lang: i18n.language == "ar" ? "ar_001" : "en_US",
        shop_type_id: id,
      });
      setCategories(response?.data?.result?.categories);
    } catch (error) {
      console.error(error);
    }
  };

  const handleLocationChange = (location) => {
    if (location) {
      setSelectedLocation(location);
      GetPolygons(location.lat, location.lng);
    }
  };

  const GetPolygons = async (latitude, longitude) => {
    try {
      const headers = {
        lang: i18n.language === "ar" ? "ar_001" : "en_US",
      };
      let payload = {
        latitude: String(latitude),
        longitude: String(longitude),
      };
      const response = await axios.post(URLS.NEW_GET_POLYGON, payload, headers);
      let location = {
        latitude: latitude,
        longitude: longitude,
      };
      data = response?.data;
      if (data?.result?.status_code === 200) {
        const geoValues = await GetGeoFencing(location, data?.result?.response);
        if (geoValues?.isInPolygon) {
          setSelectedPolygon(geoValues?.deliveryArea);
        } else {
          setSelectedPolygon({
            delivery_area: "no-area",
            delivery_area_id: "no-area",
            level: undefined,
            service_area: undefined,
          });
        }
      } else {
        setSelectedPolygon({
          delivery_area: "no-area",
          delivery_area_id: "no-area",
          level: undefined,
          service_area: undefined,
        });
      }
    } catch (error) {
      console.error(error);
    } finally {
    }
  };
  /* ============== FORMIK ============== */

  const formik = useFormik({
    enableReinitialize: true,
    validateOnBlur: false,
    validateOnChange: true,
    validateOnMount: false,
    initialValues: {
      shopType: "",
      shopName: "",
      phoneNumber: mobile || "",
      emailId: "",
      password: "",
      confirmPassword: "",
      addressLine1: "",
      addressLine2: "",
      street: "",
      city: selectedPolygon?.level || "",
      governorate: "",
      categories: [],
    },
    validationSchema,

    onSubmit: (values) => {
      const payload = {
        lang: i18n.language == 'ar' ? "ar_001" : "en_US",
        business_type: "retailer",
        shop_type: values.shopType,
        email: values?.emailId?.toLowerCase(),
        mobile: values?.phoneNumber || mobile,
        term_condition: true,
        password: values?.password,
        // owner_name: "",
        business_name: values?.shopName,
        state: values?.governorate,
        city: selectedPolygon?.level,
        street: values?.street,
        street2: `${values?.address1}${
          values?.address2 ? ", " + values?.address2 : ""
        }`,
        delivery_area: selectedPolygon?.delivery_area,
        zone_id: selectedPolygon?.delivery_area_id,
        area: selectedPolygon?.service_area,
        // country: address?.country,
        // zip: Number(values?.zip_code),
        latitude: selectedLocation?.lat || "",
        longitude: selectedLocation?.lng || "",
        categories_ids: values.categories,
      };
      onDataSubmit(payload);
    },
  });

  return (
    <div className="min-h-screen bg-background p-6 md:p-8">
      <div className="flex flex-col md:flex-row items-end md:items-start justify-between mb-8">
        <div>
          <h1 className="text-2xl font-bold text-foreground mb-1">
            {t("Shop Registration")}
          </h1>
          <p className="text-muted-foreground">
            {t(
              "Let's get your store set up. Please provide your shop's basic details and location."
            )}
          </p>
        </div>

        <Button
          onClick={formik.handleSubmit}
          className="px-8 py-3 text-base font-medium"
          size="lg"
        >
          {t("Create Account")}
        </Button>
      </div>

      <form onSubmit={formik.handleSubmit}>
        {/* ===== BASIC DETAILS ===== */}

        <div className="bg-card rounded-lg border p-5 mb-6 pt-2">
          <div className="grid grid-cols-1 md:grid-cols-2 gap-6gap-1 md:gap-6 mb-3">
            {/* ===== SHOP TYPE ===== */}
            <SelectBox
              label={t("Shop Type")}
              name="shopType"
              onChange={(event) => {
                formik.handleChange(event);

                const selected = shoptype?.find(
                  (item) => item?.shop_type_id == event.target.value
                );

                if (selected?.show_sub_cat_sign_up) {
                  GetCategorires(event.target.value);
                } else {
                  setCategories([]);
                }
              }}
              options={[
                { value: 0, label: t("Select Shop Type"), disabled: true },

                ...shoptype?.map((item) => ({
                  value: item?.shop_type_id, // ALWAYS ID
                  label: item?.shop_type,
                })),
              ]}
              onBlur={formik.handleBlur}
              value={formik.values.shopType || 0}
              error={formik.errors.shopType}
              touched={formik.touched.shopType}
            />

            {shoptype?.find(
              (item) => item?.shop_type_id == formik.values.shopType
            )?.show_sub_cat_sign_up &&
              categories?.length > 0 && (
                <div>
                  <MultiSelectBox
                    tipData={t(
                      "If you sell products by weight, select the relevant categories and the associated products will be added automatically."
                    )}
                    label={t("Categories of Products Sold by Weight")}
                    name="categories"
                    onChange={(event) => {
                      formik.setFieldValue("categories", event.target.value);
                    }}
                    placeholder={t("Select Categories")}
                    defaultValue={[]}
                    onBlur={formik.handleBlur}
                    value={formik.values.categories}
                    error={formik.errors.categories}
                    touched={formik.touched.categories}
                    options={[
                      ...categories?.map((item) => ({
                        value: item?.id,
                        label: item?.name,
                      })),
                    ]}
                  />
                </div>
              )}
          </div>
          {/* ===== SHOP NAME ===== */}
          <div className="grid grid-cols-1 md:grid-cols-2 gap-1 md:gap-6 mb-3">
            <InputBox
              name="shopName"
              label={t("Company & Business Name")}
              placeholder={t("Company Name")}
              onChange={(val) => formik.handleChange(val)}
              onBlur={formik.handleBlur}
              value={formik.values.shopName}
              error={formik.errors.shopName}
              touched={formik.touched.shopName}
            />

            {/* ===== PHONE (NON EDITABLE) ===== */}
            <div className="flex flex-col mt-4">
              <label className="text-sm text-gray-800 font-medium">
                {t("Mobile")}
              </label>

              <div className="flex items-center justify-between">
                <div className="h-10 mt-2 w-16 outline-none focus:outline-none  rounded-lg border p-3 flex items-center justify-center bg-[#EBEBEB]">
                  <img src={FlagIcon} alt="img" />
                </div>
                <div className="w-[87%]">
                  <InputBox
                    name="phoneNumber"
                    // label={t("Mobile")}
                    international
                    placeholder="24026890789"
                    onChange={(val) => formik.handleChange(val)}
                    onBlur={formik.handleBlur}
                    value={"0" + formik.values.phoneNumber}
                    error={formik.errors.phoneNumber}
                    touched={formik.touched.phoneNumber}
                    disabled
                  />
                </div>
              </div>
            </div>
          </div>

          {/* ===== EMAIL + PASSWORD ===== */}
          <div className="grid grid-cols-1 md:grid-cols-3 gap-2 md:gap-6">
            <InputBox
              name="emailId"
              label={t("email")}
              placeholder="example@gmail.com"
              onChange={(val) => formik.handleChange(val)}
              onBlur={formik.handleBlur}
              value={formik.values.emailId}
              error={formik.errors.emailId}
              touched={formik.touched.emailId}
            />
            <div>
              <Password
                label={t("Password")}
                name="password"
                placeholder={t("Enter Password")}
                onChange={(e) => formik.handleChange(e)}
                onBlur={formik.handleBlur}
                value={formik.values.password}
                error={formik.errors.password}
                touched={formik.touched.password}
              />

              {formik.errors.password &&
                formik.errors.password != "Required" && (
                  <div className="text-xs text-red mt-1">
                    {t(formik.errors.password)}
                  </div>
                )}
            </div>

            <div>
              <Password
                label={t("confirm_password")}
                name="confirmPassword"
                placeholder={t("Re-Enter Password")}
                onChange={(e) => formik.handleChange(e)}
                onBlur={formik.handleBlur}
                value={formik.values.confirmPassword}
                error={formik.errors.confirmPassword}
                touched={formik.touched.confirmPassword}
              />
              {formik.errors.confirmPassword &&
                formik.errors.confirmPassword != "Required" && (
                  <div className="text-xs text-red mt-1">
                    {t(formik.errors.confirmPassword)}
                  </div>
                )}
            </div>
          </div>
        </div>

        {/* ===== LOCATION ===== */}

        <div className="bg-card rounded-lg border p-5 pt-2">
          <div className="grid grid-cols-1 md:grid-cols-2 gap-1 md:gap-6 mb-3">
            <InputBox
              name="addressLine1"
              label={t("address1")}
              placeholder={t("enter_shopno")}
              onChange={(val) => formik.handleChange(val)}
              onBlur={formik.handleBlur}
              value={formik.values.addressLine1}
              error={formik.errors.addressLine1}
              touched={formik.touched.addressLine1}
            />

            <InputBox
              name="addressLine2"
              label={t("address2")}
              placeholder={t("landmark")}
              onChange={(val) => formik.handleChange(val)}
              onBlur={formik.handleBlur}
              value={formik.values.addressLine2}
              error={formik.errors.addressLine2}
              touched={formik.touched.addressLine2}
            />
          </div>

          <div className="grid grid-cols-1 md:grid-cols-3 gap-2">
            <InputBox
              name="street"
              label={t("street")}
              placeholder={t("enter_street")}
              onChange={(val) => formik.handleChange(val)}
              onBlur={formik.handleBlur}
              value={formik.values.street}
              error={formik.errors.street}
              touched={formik.touched.street}
            />

            <InputBox
              name="city"
              label={t("city")}
              placeholder={t("Enter City")}
              onChange={(val) => formik.handleChange(val)}
              onBlur={formik.handleBlur}
              value={formik.values.city}
              error={formik.errors.city}
              touched={formik.touched.city}
            />

            <InputBox
              name="governorate"
              label={t("Governorate")}
              placeholder={t("Enter Governorate")}
              onChange={(val) => formik.handleChange(val)}
              onBlur={formik.handleBlur}
              value={formik.values.governorate}
              error={formik.errors.governorate}
              touched={formik.touched.governorate}
            />
          </div>
        </div>
      </form>
    </div>
  );
};

export default ShopRegistration;
